import React, {ReactElement} from 'react';
import {IntlProvider} from 'react-intl';
import {CookiesProvider} from 'react-cookie';
import DeviceContext, {useDevice} from './DeviceContext';
import LocaleContext, {Locale} from './LocaleContext';
import {IdentityContextProvider} from './IdentityContext';
import useHandleFoid from '../useHandleFoid';
import useHandleLandingUrl from '../useHandleLandingUrl';
import Modal from './ModalContextProvider';
import i18n from '../../i18n';
import IncludeTermsModal from '../components/TermsModal/IncludeTermsModal';
import {DEFAULT_LOCALE} from '../constants';

export interface SiteContextProviderProps {
  children?: ReactElement;
  pageContext: {
    locale: Locale;
  };
  language: Locale;
}

const SiteContextProvider = ({
  children,
  pageContext: {locale = DEFAULT_LOCALE},
  language = DEFAULT_LOCALE,
}: SiteContextProviderProps): ReactElement => {
  const device = useDevice();
  useHandleFoid();
  useHandleLandingUrl();

  // set Identity first, so we can pull locale/etc out of user object later
  return (
    <CookiesProvider>
      <IntlProvider key={language} locale={language} messages={i18n(language)} defaultLocale={DEFAULT_LOCALE}>
        <LocaleContext.Provider value={locale}>
          <IdentityContextProvider>
            <DeviceContext.Provider value={device}>
              <Modal>
                {/* Reliant on modal context so must be included here to work globally */}
                <>
                  <IncludeTermsModal />
                  {children}
                </>
              </Modal>
            </DeviceContext.Provider>
          </IdentityContextProvider>
        </LocaleContext.Provider>
      </IntlProvider>
    </CookiesProvider>
  );
};

export default SiteContextProvider;
